import { OutputPage } from '@/components/output/output-page';

export function Output() {
  return <OutputPage />;
}